// Tesla error codes. If we receive one of these from Tesla, 
// after the attempt to create an account, 
// we surface the related message to the user on form.  
// If we don't receive one of the below codes, we "dead end" the user

export const errorMessages = [
	'RISK_DENIED',
	'INSTRUMENT_SHARING_LIMIT_EXCEEDED',
	'ISSUER_DECLINE',
	'VALIDATION_ERROR',
	'ALIAS_UNAVAILABLE'
];

/**
 * Determines if the error code is one that we have flagged 
 * as one that we should surface to the user.
 * 
 * @param  {String} errorCode   Tesla errorCode "RISK_DENIED"
 * @return {Boolean}            true or false
 */
export const isTeslaErrorMessage = (errorCode) => {
	return errorMessages.includes(errorCode);
}


// WEBPACK FOOTER //
// ./utility/teslaUtility.js